import { useRef, useCallback } from 'react';

const TONES = { orb: [660, 0.07], gem: [990, 0.14], bomb: [120, 0.25] };

export const useSfx = (enabled) => {
  const ctxRef = useRef(null);
  return useCallback((kind) => {
    if (!enabled) return;
    if (kind === 'bomb' && navigator.vibrate) navigator.vibrate(60);
    try {
      if (!ctxRef.current) ctxRef.current = new (window.AudioContext || window.webkitAudioContext)();
      const ac = ctxRef.current;
      const [freq, dur] = TONES[kind];
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.type = kind === 'bomb' ? 'sawtooth' : 'sine';
      osc.frequency.setValueAtTime(freq, ac.currentTime);
      gain.gain.setValueAtTime(0.12, ac.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + dur);
      osc.connect(gain).connect(ac.destination);
      osc.start();
      osc.stop(ac.currentTime + dur);
    } catch (e) {
      console.warn('[sfx] audio unavailable', e);
    }
  }, [enabled]);
};
